<template>
  <textarea></textarea>
</template>
<script>
export default {
  name: 'WordEditor',
};
</script>
<style lang="stylus" scoped>
.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused)
  min-height 250px
</style>
